import Header from './components/Header';
import HeroSection from './components/HeroSection';
import AppSection from './components/AppSection';
import AboutSection from './components/AboutSection';
import IndexSection from './components/IndexSection';
import RankingSection from './components/RankingSection';
import FaqSection from './components/FaqSection';
import CommentsSection from './components/CommentsSection';
import TopicsSection from './components/TopicsSection';
import CardsSection from './components/CardsSection';
import FeaturesSection from './components/FeaturesSection';
import UpdatesSection from './components/UpdatesSection';
import MediaSection from './components/MediaSection';
import CarouselSection from './components/CarouselSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />

      <main>
        <HeroSection />
        <AppSection />
        <AboutSection />
        <IndexSection />
        <RankingSection />
        <FaqSection />
        <CommentsSection />
        <TopicsSection />
        <CardsSection />
        <FeaturesSection />
        <UpdatesSection />
        <MediaSection />
        <CarouselSection />
        <ContactSection />
      </main>

      <Footer />
    </>
  );
}